import { render, staticRenderFns } from "./WebPushSettings.vue?vue&type=template&id=3127a1d4&"
import script from "./WebPushSettings.vue?vue&type=script&lang=ts&"
export * from "./WebPushSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports